import { useAuth0 } from "@auth0/auth0-react";
import { useProfileQuery } from "../user/profile";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "../utils";
import request from "@/lib/api/handler";
import {
  ICandidateObject,
  IExperience,
} from "@/redux/features/candidateProfileSlice";

export type Candidate = ICandidateObject;

export const sortExperiences = (a: IExperience, b: IExperience): number => {
  if (!a.endDate && b.endDate) {
    return -1;
  } else if (a.endDate && !b.endDate) {
    return 1;
  } else if ((a.endDate ?? "") < (b.endDate ?? "")) {
    return 1;
  } else if ((a.endDate ?? "") > (b.endDate ?? "")) {
    return -1;
  } else if ((a.startDate ?? "") < (b.startDate ?? "")) {
    return 1;
  } else if ((a.startDate ?? "") > (b.startDate ?? "")) {
    return -1;
  }

  return 0;
};

export const useCandidateQuery = (id?: string) => {
  const { profile } = useProfileQuery();
  const { getAccessTokenSilently } = useAuth0();
  const uid = id ?? profile?.id ?? "";

  const { isLoading, data, error } = useQuery({
    queryKey: QueryKeys.candidate(uid),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled: !!uid,
    async queryFn() {
      const token = await getAccessTokenSilently();
      const resp: { candidate: Candidate } = await request({
        method: "GET",
        path: `/api/candidate/${uid}`,
        token,
      });

      resp.candidate.experiences.sort(sortExperiences);

      return resp.candidate;
    },
  });

  return {
    candidateLoading: isLoading,
    candidate: data ?? null,
    candidateError: error ?? null,
  };
};
